import React from "react";
import { Helmet } from "react-helmet";

import "@css/layout.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Layout({ children }) {
  return (
    <div
      style={{
        margin: `0 auto`,
        maxWidth: "540px",
        // borderLeft: "1px solid black",
        // borderRight: "1px solid black",
        padding: `0`,
        backgroundColor: "white",
        // position: "relative",
      }}
    >
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/vrx7tja.css" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
      {children}
    </div>
  );
}
